export default "__VITE_ASSET__Ss53$wMA__"